import SectionLabel from "./SectionLabel";

export default function TransformationThesis() {
  return (
    <section className="av-section av-thesis" aria-labelledby="av-thesis-title">
      <div className="av-shell av-split">
        <div>
          <SectionLabel>Our perspective</SectionLabel>
          <h2 id="av-thesis-title">
            Transformation works when technology and operations change together.
          </h2>
        </div>
        <div className="av-reading-copy">
          <p>
            Many programmes separate strategy, implementation and adoption.
          </p>
          <p>
            Averentia brings these workstreams into one delivery plan with clear
            owners, regular reviews and agreed measures.
          </p>
        </div>
      </div>
    </section>
  );
}
